import { useQuery } from '@mint-lib/query-client';
import { MediaPlan } from '@mint-sdk/api-media-plan';
import { getRouteApi } from '@mint/routing';

const routerApi = getRouteApi(
  '/_secured/campaign/$campaignId/planning/buying-plan',
);

export const useBudgetingStructuresApi = () => {
  const { campaignId: planId } = routerApi.useParams();

  const { data, ...rest } = useQuery(
    MediaPlan.getBudgetingStructuresListQueryOptions({
      urlParams: {
        mediaPlanId: planId,
      },
    }),
  );

  return { data: data?.data?.items, ...rest };
};
